exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs[data-v-cd8f6894]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-bottom:16px}.tabs .tab[data-v-cd8f6894]{padding:10px 16px}", ""]);

// exports
